import React from 'react';

interface Entity {
  name: string;
  url_identifier: string;
}

interface Props {
  entity: Entity;
}

function EntityName(props: Props): React.ReactElement {
  return (
    <a href={`/${props.entity.url_identifier}/`} target="_blank" rel="noopener noreferrer">
      {props.entity.name}
    </a>
  );
}

export default EntityName;
